import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PortalERACREPORTTable from './erac-report-table.jsx';

if (document.getElementById('react-component-g4-logistics-portal-admin-erac')) {
    ReactDOM.render(<PortalERACREPORTTable/>,
    document.getElementById('react-component-g4-logistics-portal-admin-erac'));
}
